export default __webpack_public_path__ + "locales/si/Common.json?hash=28847c6de49e67183d4ac2faf14f76ff";